import { CurrencyPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { AppResource } from 'src/app/app.resource';
import { CombinedStore } from 'src/app/core/combined.store';
import { SvgViewerComponent } from 'src/app/shared/components/svg-viewer/svg-viewer.component';
import { getProductInfo } from 'src/app/shared/constants/product.constants';
import { SvgVM } from 'src/app/shared/models/model/concretes/components/svg.model';

@Component({
  selector: 'app-vyv-summary',
  standalone: true,
  imports: [CurrencyPipe, SvgViewerComponent],
  templateUrl: './vyv-summary.component.html',
  styles: [],
})
export class VyvSummaryComponent implements OnInit {
  public resource = inject(AppResource)['resource'];
  store = inject(CombinedStore);

  ngOnInit(): void {
    // ACTIVATE STORE SUMMARY
    const productName = getProductInfo(this.store.path())!.name;
    this.svg = new SvgVM(`assets/common/offerCustomize/${productName}.svg`, 'white');
  }

  svg!: SvgVM;

  isNumber(value: string): boolean {
    return value?.trim() !== '' && !isNaN(Number(value));
  }
}
